import { Component } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { WarehouseLocation } from '../../models/warehouse-location.model';
import { WarehouseLocationService } from '../../services/warehouse-location.service';
import { WarehouseLocationValidatorService } from '../../validators/warehouse-location-validator.service';

@Component({
    selector: 'app-locations-new',
    templateUrl: './locations-new.component.html',
    styleUrls: ['./locations-new.component.scss'],
    standalone: false
})
export class LocationsNewComponent {

  warehouseLocation: WarehouseLocation = new WarehouseLocation();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private warehouseLocationValidator: WarehouseLocationValidatorService,
    private warehouseLocationService: WarehouseLocationService) { }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if (this.warehouseLocationValidator.isValid(this.warehouseLocation)) {
      this.warehouseLocationService.createWarehouseLocation(this.warehouseLocation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/warehousing/locations';
      })
    } else {
      this.isError = true;
    }
  }
}
